<ng-container
  *ngVar="{
    hasPendingAccess: (hasPendingAccess$ | async),
    canDownloadEvidence: (canDownloadEvidence$ | async),
    isLoggedIn: (isLoggedIn$ | async)
  } as data"
>
  @switch (true) {
    @case (data.canDownloadEvidence) {
      @if (isUrlEvidence) {
        <app-new-button
          class="url-btn"
          [size]="'responsive'"
          [type]="'basic'"
          [svgIconPath]="'newscreen'"
          [disabled]="!evidences[0].evidence_url"
          (click)="$event.stopPropagation(); openLinkEvidence(evidences[0].evidence_url)"
        >
          {{ buildTranslationKey('openInTab') | translate }}
        </app-new-button>
      } @else {
        <app-new-button
          class="download-btn"
          [loading]="loading$ | async"
          [saveButtonSizeDuringLoading]="true"
          [size]="'responsive'"
          [type]="'basic'"
          [svgIconPath]="'download'"
          (click)="$event.stopPropagation(); downloadEvidence(evidences[0])"
        >
          {{ buildTranslationKey('download') | translate }}
        </app-new-button>
      }
    }
    @case (data.hasPendingAccess) {
      @if (areAllFilesPrivate) {
        <app-new-button
          class="pending-access-btn"
          [size]="'responsive'"
          [type]="'basic'"
          [svgIconPath]="'lock'"
        >
          {{ buildTranslationKey('pendingAccess') | translate }}
        </app-new-button>
      }
    }
    @case (data.hasPendingAccess === false) {
      @if (areAllFilesPrivate && !data.isLoggedIn) {
        <app-icon-button class="request-access-btn" [type]="'basic'" [svgIconPath]="'lock'"></app-icon-button>
      }
    }
  }
</ng-container>
